'use strict';
import commonApiRequest from '../service/common/apiRequest';
import kcmApiRequest from '../service/kcmCert/request';
import defaultRegion from '../service/util/defaultRegion';
import getRegionChina from "../service/common/getRegionChinaFunc";
import { releaseConfig } from "../service/common/initEdition";
import * as _ from 'lodash';
import {Component, Watch, Vue} from 'vue-property-decorator'
import { namespace } from "vuex-class";

const slbModule = namespace('slb');

//公共方法

@Component
export default class CommonRoot extends Vue {
    inFrame = window.location !== window.parent.location

    // global variables
    RowTailDropdownPosition = {my:"right top-5", at: "right bottom"}


    setCookie(name: any, value: any, days: any) {
        const me = this;
        let domain = "." + releaseConfig.domain;
        let expires = '';

        if (days) {
            let date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;

        if (me.getCookie(name) == null || me.getCookie(name) != value) {
            document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
        }
    }
    getCookie(name: any) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    getRegion(cb: any) {
        __ksStorage__.getValue('region', (k, v) => {
            cb && cb(v);
        });
    }
    setRegion(value: any, cb: any) {
        localStorage.systemId = value;
        __ksStorage__.setValue('region', value, () => {
            cb && cb();
        });
    }

    eraseCookie(name: any) {
        localStorage.systemId = '';
    }
    checkRegion(regions: any, curRegion: any) {
        const me: any = this;
        // if (me.inFrame && window.location.hash.indexOf("epcsafe") !== -1) {
        if (window.location.hash.indexOf("epcsafe") !== -1) {
            if (KSC_SECNET_CONSOLE.ENV != "prod") {
                regions = [{"isVpc": 1, "name": "庆阳1区(测试)", "code": "cn-qingyangtest-1"}];
            } else {
                regions = [
                    {"isVpc": 1, "name": "北京6区(VPC)", "code": "cn-beijing-6"},
                    {"isVpc": 1, "name": "上海2区(VPC)", "code": "cn-shanghai-2"},
                    {"isVpc": 1, "name": "俄罗斯1区(VPC)", "code": "eu-east-1"},
                    {"isVpc": 1, "name": "广州1区(VPC)", "code": "cn-guangzhou-1"},
                ];
            }
        }

        let curRegionDetail = _.find(regions, ['code', curRegion]);
        if (!curRegion || !curRegionDetail) {
            // 默认选取vpc机房
            // 没有vpc机房就选第一个机房
            let r = _.find(regions, ['isVpc', 1]);
            if (!r) {
                r = _.find(regions, (n) => {
                    return n.name && n.name.toLowerCase().indexOf('vpc') != -1;
                });
            }
            if (!r) {
                r = regions[0]
            }
            curRegion = r ? r.code : '';
            curRegionDetail = r;
        }


        me.setRegion(curRegion);
        //判断机房是否大于三个 带过去参数
        //if大于三个 传ismore=1 vpcregions basicregions
        var isMore;
        if (regions.length > 3) {
            var vpcRegions: any = [];
            var basicRegions: any = [];
            isMore = 1;
            _.forEach(regions, function (item) {
                const tempData = item.code.split('-');
                const areaCode = (tempData && tempData.length) ? tempData[0] : 'cn';
                const areaKey = getRegionChina(areaCode);
                const regionKey = getRegionChina(item.name);

                item.areaCode =  areaCode.toUpperCase(); //areaCode 需要大写
                item.areaName = areaKey ? Vue.$trans(areaKey) : '国内';
                item.areaEnName = areaKey ? Vue.$trans(areaKey) : 'China';
                item.regionCode = item.code;
                item.regionName = regionKey ? Vue.$trans(regionKey) : item.name;
                item.regionEnName = regionKey ? Vue.$trans(regionKey) : item.name;

                if (item.isVpc == 1) {
                    vpcRegions.push(item)
                } else {
                    basicRegions.push(item)
                }
            })
            if (vpcRegions.length > 5) {
                var vpcRegionsClone = _.cloneDeep(vpcRegions);
                vpcRegions = vpcRegionsClone.slice(0, 5);
                var vpcRegionsOther = vpcRegionsClone.slice(5, vpcRegionsClone.length);
                basicRegions = vpcRegionsOther.concat(basicRegions);
            }
        } else {
            isMore = 0;
        }

        // 在主机或EPC控制台不是按照路由配置，这个MENU_REGION是undefined;
        if (me.$route.name === 'group' && (location.hostname.indexOf("kec") > -1 || location.hostname.indexOf("epc") > -1 || location.hostname.indexOf("abc") > -1)) {
            window.MENU_REGION = true; //这种情况默认是显示的
            window.MENU_REGION_ITEM = undefined;
        }
        
        if (!window.MENU_REGION && window.MENU_REGION_ITEM !== undefined) {
            window.MENU_REGION_ITEM.remove();
            window.MENU_REGION_ITEM = undefined;
        }
        if(window.MENU_REGION && window.MENU_REGION_ITEM === undefined && regions.length > 0){
            window.MENU_REGION_ITEM = __ksStorage__.initRegion(regions, curRegion);
        }

        return {
            allRegions: regions,
            curRegion,
            curRegionDetail,
            isMore: isMore,
            vpcRegions: vpcRegions,
            basicRegions: basicRegions,
            vpcRegionsOther: vpcRegionsOther
        };
    }

    // 获取机房信息 全局缓存!!!!
    loadRegion(SrcService?: any) {
        let me: any = this;
        if (!SrcService) {
            SrcService = me.$route.path.match(/(eip\/bws)|eip|slb|vpc|dc|vpn|pdns/);
            SrcService = SrcService ? SrcService[0] : null;
        }
        let SrcServiceOther = me.$route.path.match(/(vpc\/natIndex)|(vpc\/connectIndex)/);
        if (SrcServiceOther && SrcServiceOther[0] == "vpc/natIndex") {
            SrcService = "vpc/natIndex";
        }
        if (SrcServiceOther && SrcServiceOther[0] == "vpc/connectIndex") {
            SrcService = "vpc/connectIndex";
        }
        // Service = Service || 'eip';
        SrcService = SrcService || 'eip';
        let serviceMap: any = {
            eip: 3,
            slb: 6,
            vpc: '',
            sec: '',
            bws: 57,
            nat: 54,
            dc: '',
            vpn: '',
            pdns: 476,
            // pdns: 3,
            'eip/bws': 57
        };
        let Service: any = serviceMap[SrcService];

        let groupMap: any = {
            eip: 102,
            slb: 105,
            vpc: 102,
            sec: '',
            bws: 113,
            'vpc/natIndex': 112,
            'vpc/connectIndex': 102,
            dc: 102,
            vpn: 144,
            pdns: 251,
            // pdns: 102,
            'eip/bws': 113
        };
        let groupId = groupMap[SrcService];

        Service = Service || 3;
        groupId = groupId || '';
        let uName = "";
        let strRegion = this.$route.path;
        return new Promise((resolve, reject) => {
            window.__ksStorage__.getBaseInfo('userInfo', function (userData: any) {
                uName = userData.user.username || "";
                var regions = localStorage.networkRegions;
                try {
                    regions = JSON.parse(regions);

                    // let uname = $('header .user-name').text();
                    // uname = $.trim(uname);
                    let uname = uName;

                    if (!uname || uname !== regions.uname) {
                        regions = null;
                    } else if (!regions.env || regions.env !== KSC_SECNET_CONSOLE.ENV || regions.service !== SrcService || regions.ver !== KSC_SECNET_CONSOLE.VER) {
                        regions = null;
                    } else if (!regions.ts) {
                        regions = null;
                    } else {
                        if (Date.now() - regions.ts > 30 * 60 * 1000) {
                            regions = null;
                        } else {
                            regions = regions.data;
                        }
                    }
                } catch (e) {
                    regions = [];
                }

                me.getRegion((curRegion: any) => {
                    //kcm接入新价格体系
                    // let strRegion = me.$route.path;
                    let isKcm = strRegion.indexOf('kcm/cert') != -1;
                    let isNewKcm = strRegion.indexOf('kcm/kcm-new') != -1;

                    if (isKcm || isNewKcm) {
                        me.getRegionsFromPriceSys('kcm').then((data: any) => {
                            regions = data.regions;
                            let res = me.checkRegion(regions, curRegion);
                            res.queryPriceData = _.get(data, 'data');
                            res.curRegion = defaultRegion;
                            resolve(res);
                        })
                        return;
                    }

                    //如果是应用型SLB 服务器组 请求新接口获取机房信息
                    let isApplySlb = strRegion.indexOf('slb/apply-slb');
                    let isApplyServer = strRegion.indexOf('slb/apply-server');

                    if (isApplySlb != -1 || isApplyServer != -1) {
                        me.getApplySlb().then((data: any) => {
                            regions = data.regions;

                            let res = me.checkRegion(regions, curRegion);
                            resolve(res);
                        });
                        return;
                    }

                    if (regions && regions.length) {
                        let res = me.checkRegion(regions, curRegion);
                        resolve(res);
                        return;
                    }

                    let paramsRegions = {
                        type: Service,
                        productGroupId: groupId,
                        isVpc: false,
                    }
                    if (SrcService == "vpc" || SrcService == "vpc/connectIndex") {
                        paramsRegions.isVpc = true;
                    }

                    commonApiRequest.GetRegions(paramsRegions).done((data: any) => {
                        let tem: any[] = [];
                        _.forEach(data, (r) => {
                            tem.push({
                                isVpc: r.isVpc,
                                name: r.region_name,
                                code: r.region_code
                            });
                        });
                        let list = [
                            'cn-beijing-6',
                            'cn-shanghai-2',
                            'cn-hongkong-2',
                            'cn-beijing-1-new',
                            'cn-shanghai-1'
                        ]
                        tem.sort((a, b) => {
                            let aIdx = list.indexOf(a.code)
                            if (aIdx == -1) {
                                aIdx = 100
                            }
                            let bIdx = list.indexOf(b.code)
                            if (bIdx == -1) {
                                bIdx = 100
                            }
                            return aIdx - bIdx;
                        });
                        data = tem;

                        localStorage.networkRegions = JSON.stringify({
                            data,
                            service: SrcService,
                            env: KSC_SECNET_CONSOLE.ENV,
                            ver: KSC_SECNET_CONSOLE.VER,
                            ts: Date.now(),
                            // uname: $.trim($('header .user-name').text())
                            uname: uName,
                        });
                        regions = data;
                        let res = me.checkRegion(regions, curRegion);
                        resolve(res);
                    }).fail(() => {
                        reject();
                    });
                });
            });
        });
    }

    @slbModule.Action('loadRegionsOfAppSlb')
    getApplySlb: any

    // getApplySlb() {
    //
    //     // const me: any = this;
    //     // return new Promise((resolve, reject) => {
    //     //     commonApiRequest.GetRegionsOfAppSlb(
    //     //         {
    //     //             ProductGroupId: 105,
    //     //             ProductTypeId: 117
    //     //         }).done((data: any) => {
    //     //         let arr: any = [];
    //     //         let regions: any = [];
    //     //         _.forEach(data, (r) => {
    //     //             arr.push({
    //     //                 isVpc: r.isVpc,
    //     //                 name: r.region_name,
    //     //                 code: r.region_code
    //     //             })
    //     //         })
    //     //         // me.isShowApplyList = regions;
    //     //
    //     //         regions = arr;
    //     //         let json = {
    //     //             isShow: true, //data.hasPermission,
    //     //             regions: regions
    //     //         }
    //     //         resolve(json)
    //     //     });
    //     // })
    // }

    loadPriceRegion(Service:any, o_type:any) {
        o_type = o_type || 'create';
        o_type = ({
            create: 1,
            update: 3
        } as any)[o_type];

        const me:any = this;
        Service = Service || 'eip';
        return new Promise((resolve, reject) => {
            let method:string;
            switch(Service) {
                case 'eip':
                    method = 'DescribePriceSystemOfEip';
                    break;
                case 'bws':
                    method = 'DescribePriceSystemOfBws';
                    break;
                case 'slb':
                    method = 'DescribePriceSystemOfSlb';
                    break;
                case 'nat':
                    method = 'DescribePriceSystemOfNAT';
                    break;
                case 'vmIPv6Eip':
                    method = 'DescribePriceSystemOfIpv6Public';
                    break;
                default:
                    method = 'DescribePriceSystem';
            }

            let params:any = {
                Service,
                operate_type: o_type,
            }

            if (Service == "eip" || Service == "bws" || Service == "nat" || Service === 'vmIPv6Eip') {
                params.Service = "price";
            }

            commonApiRequest[method](params).done((data:any) => {

                let tem:any = [];
                _.forEach(data.DataCenterSet, (d) => {
                    _.forEach(d.RegionSet, (r) => {
                        r.name = r.Name;
                        r.code = r.Region;
                        r.isVpc = r.Name.toLowerCase().indexOf('vpc') != -1;
                        r.DataCenterId = d.DataCenterId
                        tem.push(r);
                    });
                });
                me.getRegion((curRegion:any) => {
                    var res = me.checkRegion(tem, curRegion);
                    res.DataCenterSet = data.DataCenterSet;
                    // 与后端约定的vGBP链路最小带宽值
                    if (data.ProductIspBandwidthList) {
                        res.ProductIspBandwidthList = data.ProductIspBandwidthList;
                    }
                    resolve(res);
                });
            }).fail(() => {
                reject();
            });
        });
    }


    //计算网段
    // getDhcp
    // 使用 http://ip-address.js.org/ 替换

    //新价格体系获取机房
    getRegionsFromPriceSys(Service:any) {
        return new Promise((resolve, reject) => {
            kcmApiRequest.QueryPriceSystemNew().done((data:any) => {
                let productData = _.get(data, ['data', 'productTypeList']);
                // data = _.get(data,['data','productTypeList','0','regionList']) || [];
                let regionData:any = [];
                _.each(productData, product => {
                    _.each(product.packageList, item => {
                        regionData.push(item.refRegionList)
                    })
                })
                regionData = _.unionWith(_.flattenDeep(regionData), (a:any, b:any) => a.regionCode === b.regionCode);
                __ksStorage__.getValue('region', (k, v) => {
                    let result:any = [],
                        activeRegion,
                        hitCache = false;
                    regionData.forEach((item:any) => {
                        let region = {
                            code: item.regionCode,
                            name: item.regionName,
                            active: false
                        }
                        if (item.regionCode === v) {
                            region.active = true;
                            hitCache = true;
                            activeRegion = region;
                        }
                        result.push(region)
                    });
                    if (!hitCache && result.length > 0) {
                        result[0].active = true;
                        activeRegion = result[0];
                    }
                    resolve({
                        regions: result,
                        activeRegion,
                        data: productData
                    });
                })
            }).fail((e:any) => {
                reject([]);
            })
        });
    }


};
